<div *ngIf="messages.length > 0" class="snackbar-wrapper">
  <div class="alert" *ngFor="let message of messages; let i=index" [ngClass]="{
    'alert-success': message.type === 'success',
    'alert-danger': message.type === 'error',
    'alert-warning': message.type === 'warning',
    'alert-info': message.type === 'info',
    'alert-primary': message.type === 'primary'}">

    <button type="button" (click)="close(i)" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>

    {{message.error.MESSAGE}}

    <div *ngIf="message.isBug" class="button-wrapper mt-2">
      <button (click)="sendReport(message.error)" type="button" class="btn rounded-0" [ngClass]="{
        'btn-outline-success': message.type === 'success',
        'btn-outline-danger': message.type === 'error',
        'btn-outline-warning': message.type === 'warning',
        'btn-outline-info': message.type === 'info',
        'btn-outline-primary': message.type === 'primary'}">Send Bug Report</button>
    </div>
  </div>
</div>

<!--
<div class="help-wrapper" (click)="onSendFeedBack()">
  <fa name="fa fa-commenting-o"></fa>
</div> -->
